import ForgotPasswordForm from 'profile/login/forms/ForgotPasswordForm';

const ReturningCustomer = () => (
  <div className="c7-account-login--returning-customer">
    <h4>Forgot Password</h4>
    <ForgotPasswordForm
      redirectLink="/checkout/checkout"
      loginLink="/checkout/login"
    />
  </div>
);

export default ReturningCustomer;
